var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * @packageDocumentation
 * @module      CorLogoBar.ts
 * @description A Shui Access Bar that only shows the logo and has no box shadow.
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
import { LitElement, html, customElement, css } from 'lit-element';
import './CorThemeSelector';
import { universalStyles } from "./CorMain";
/**
 * A Shui Access Bar that only shows the logo and has no box shadow.
 * We use it at the top of pages that require just a logo because at this moment
 * there is no Shui component that has just the logo.
 */
let CorLogoBar = class CorLogoBar extends LitElement {
    /**
     * LitElement looks for a static property by this name. If it finds one, it applies these styles to the component.
     * See https://lit-element.polymer-project.org/guide/styles#expressions
     */
    static get styles() {
        return css `
          ${universalStyles}

          sh-access-bar {
            box-shadow: none;
          }
        `;
    }
    /** Renders the component as part of LitElement's lifecycle. */
    render() {
        return html `<sh-access-bar logo="./assets/img/Corindus Logo.svg"></sh-access-bar>`;
    }
};
CorLogoBar = __decorate([
    customElement('cor-logo-bar')
], CorLogoBar);
export { CorLogoBar };
//# sourceMappingURL=CorLogoBar.js.map